// extracted by mini-css-extract-plugin
module.exports = {"article":"index-article-3WmvM"};